import { useEffect, useMemo } from "react";
import { useFilters } from "core/features/filters/store";
import { useFiltersLists } from "core/features/filters/store/lists";
import { filterVisibleRainfallLegendIndices } from "core/features/maps/rainfall-interpolation";

export function useMapaDeChuvaIndices() {
  const { mapaDeChuvas, loadings } = useFiltersLists();
  const { filters, updateFiltroMapaDeChuvas } = useFilters();
  const { filtroMapaDeChuva } = filters;

  const visibleIndices = useMemo(
    () => filterVisibleRainfallLegendIndices(mapaDeChuvas?.indices),
    [mapaDeChuvas?.indices]
  );

  const visibleCodes = useMemo(
    () => visibleIndices.map((item) => item.indicePluviometrico),
    [visibleIndices]
  );

  function handleSelectPluviometrico(code: number) {
    updateFiltroMapaDeChuvas(
      {
        indicesPluviometrico: filtroMapaDeChuva?.indicesPluviometrico
          ? [...filtroMapaDeChuva?.indicesPluviometrico, code]
          : [code],
      },
      true
    );
  }

  function handleRemovePluviometrico(code: number) {
    updateFiltroMapaDeChuvas(
      {
        indicesPluviometrico: filtroMapaDeChuva?.indicesPluviometrico.filter(
          (pluviometrico) => pluviometrico !== code
        ),
      },
      true
    );
  }

  function onChange(pluviometricoCodigo: number) {
    if (
      filtroMapaDeChuva?.indicesPluviometrico?.includes(pluviometricoCodigo)
    ) {
      handleRemovePluviometrico(pluviometricoCodigo);
    } else {
      handleSelectPluviometrico(pluviometricoCodigo);
    }
  }

  function handleClear() {
    updateFiltroMapaDeChuvas(
      {
        indicesPluviometrico: [],
      },
      true
    );
  }

  function handleSelectAll() {
    updateFiltroMapaDeChuvas(
      {
        indicesPluviometrico: visibleCodes,
      },
      true
    );
  }

  useEffect(() => {
    if (!visibleCodes.length) {
      return;
    }

    // Default: whenever the legend list changes (new period or new bands),
    // select all visible indices — including newly added ones.
    updateFiltroMapaDeChuvas(
      {
        indicesPluviometrico: visibleCodes,
      },
      true
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapaDeChuvas?.indices, filtroMapaDeChuva?.periodo]);

  return {
    items: visibleIndices,
    value: filtroMapaDeChuva?.indicesPluviometrico || [],
    onChange,
    loading: loadings.mapaDeChuvas,
    onClear: handleClear,
    onSelectAll: handleSelectAll,
  };
}
